import { Observable, from, of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import {
  NotificationAction,
  NotificationActions,
  SendInvitePushNotificationError, SendInvitePushNotification,
  SendInvitePushNotificationSuccess,
} from '../actions/notification.action';
import NotificationService from '../../shared/services/notification.service';

const sendNotificationEpic = (action$: Observable<NotificationAction>) => action$.pipe(
  ofType<SendInvitePushNotification>(NotificationActions.SendInvitePushNotification),
  switchMap(({ inviteCode, content }) => from(NotificationService.notifyJobTechnician(inviteCode, content)).pipe(
    map(() => new SendInvitePushNotificationSuccess()),
    catchError(() => of(new SendInvitePushNotificationError())),
  )),
);

export default [
  sendNotificationEpic,
];